(function () {
  if (window.__cartCheckoutPriceSynced === true) return;
  window.__cartCheckoutPriceSynced = true;

  /* Mirror del texto de .cart-subtotal-price (que ya se mantiene actualizado
     por otros flujos: js-main-cart.js en cambios de cantidad, js-cart-remove-item.js
     al eliminar) hacia el monto que va dentro del boton sticky de "Finalizar
     Pedido". Se usa un MutationObserver en vez de duplicar llamadas al carrito:
     una sola fuente de verdad, sin importar que dispara el cambio. */
  var sync = function () {
    var $source = document.querySelector('.cart-subtotal-price');
    var $target = document.querySelector('[data-cart-checkout-price]');
    if ($source == null || $target == null) return;
    var amount = $source.textContent.trim();
    if (amount === '') return;
    var newText = '\u00a0- ' + amount;
    if ($target.textContent !== newText) {
      $target.textContent = newText;
    }
  };

  sync();

  var $source = document.querySelector('.cart-subtotal-price');
  if ($source != null) {
    new MutationObserver(sync).observe($source, { childList: true, characterData: true, subtree: true });
  }
})();
